export const PROPOSAL_TIPS = [
  {
    icon: 'itaufonts_senha',
    title: 'icarros nunca entra em contato para solicitar senhas',
    description:
      'Não enviamos protocolos de atendimento via SMS. Nem entramos em contato para repassar propostas. Desconfie dessa abordagem! Não compartilhe PINS e senhas por telefone ou por WhatsApp.'
  },
  {
    icon: 'itaufonts_desafios',
    title: 'desconfie de trocas muito vantajosas',
    description:
      'Há compradores que oferecem objetos e bens em troca do carro. Quando a troca é vantajosa demais, pode ser que haja algo errado. Por isso, mantenha sempre uma certa desconfiança.'
  },
  {
    icon: 'itaufonts_outline_copiar',
    title: 'cuidado com o golpe do anúncio clonado',
    description:
      'Use uma marca d’água nas suas fotos e jamais entregue o carro sem verificar se o pagamento foi identificado pelo banco.'
  },
  {
    icon: 'itaufonts_gerenciador_de_vendas',
    title: 'não parcele por conta própria',
    description:
      'Caso você queira facilitar as opções de pagamento para vender seu carro, busque opções de financiamento pelo icarros ou Itaú. Assim, você terá mais segurança para fechar negócio.'
  }
];
